import { type CreateTRPCReact, createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@repo/api/router";
export const trpc: CreateTRPCReact<AppRouter, unknown, null> =
  createTRPCReact();
